import { useLocaleTranslation } from "@/hooks/useLocaleTranslation";
import { useStandaloneMode } from "@/hooks/useStandaloneMode";
import InstallAppInstructions from "@/components/InstallAppInstructions";

export default function InstallInstructionsPage() {
  const isStandalone = useStandaloneMode();
  const t = useLocaleTranslation();

  return (
    <div
      className={`dark px-4 max-w-xl mx-auto space-y-4 ${
        isStandalone ? "mb-24" : "mb-16"
      }`}
    >
      <InstallAppInstructions t={t} />
    </div>
  );
}
